import React, { Component } from 'react';
import PropTypes from 'prop-types';

import clickOutside from 'react-onclickoutside';
import googleUtils from '../../../lib/gmap_utils';
import { ErrorDropdown } from './error-dropdown';
import { FormattedMessage, injectIntl } from 'react-intl';

class LocationDropdown extends Component {
  constructor (props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.autoComplete = this.autoComplete.bind(this);
    this.highlightText = this.highlightText.bind(this);
    this.predictionItem = this.predictionItem.bind(this);
    this.renderOptions = this.renderOptions.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onFocusLocation = this.onFocusLocation.bind(this);
    this.onBlurLocation = this.onBlurLocation.bind(this);
    this.openLocationDropDown = this.openLocationDropDown.bind(this);
    this.checkSelected = this.checkSelected.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
    this.checkForIcon = this.checkForIcon.bind(this);

    this.state = {
      menuStatus: '',
      location: '',
      locationPlaceholder: this.props.intl.formatMessage({ id: 'boards.location_dropdown.where', defaultMessage: 'Where?' }),
      locationFocus: true,
      predictions: '',
      enableLClickOutside: false,
      whichDropdown: 'location',
      placeId: '',
      userSelected: false
    };
  }

  componentWillMount () {
    if (this.props.location) {
      this.setState({ userSelected: true });
    }
  }

  componentWillUpdate (nextProps, nextState) {
    const { userSelected } = nextState;
    if (this.state.userSelected && (userSelected !== this.state.userSelected)) {
      this.props.clickCallback('');
    }
  }

  handleClickOutside (e) {
    const ignoreClickOutside = $(e.target).hasClass('ignore-location-clickoutside');
    if (this.state.enableLClickOutside && !ignoreClickOutside) {
      this.closeDropdown();
      if (this.state.predictions) {
        if (!$('#metro-list-0 a').hasClass('hovered')) {
          $('#metro-list-0 a').addClass('hovered');
        }
      }
    }
  }

  closeDropdown () {
    this.setState({
      menuStatus: '',
      enableLClickOutside: false
    });
  }

  openLocationDropDown () {
    this.setState({
      menuStatus: 'open',
      enableLClickOutside: true
    });
  }

  onChange (e, val) {
    const location = e ? e.currentTarget.value : val;

    this.setState({
      location,
      userSelected: false
    });

    if (location) {
      this.autoComplete(location);
    } else {
      this.setState({
        placeId: '',
        predictions: '',
        whichDropdown: 'location'
      });
    }
  }

  onClick (e) {
    e.stopPropagation();
    e.preventDefault();
    const targetElement = e.currentTarget;
    const location = targetElement.getAttribute('data-name');
    const locationInput = this.refs.locationInput;

    locationInput.value = location;

    this.setState({
      menuStatus: '',
      location,
      placeId: targetElement.getAttribute('data-placeid'),
      userSelected: true
    });
    this.props.errorFn(true);
    this.props.clickCallback(location);
  }

  autoComplete (input, callback) {
    const completer = googleUtils.autoCompleteService();

    const options = {
      input,
      types: ['geocode']
    };

    completer.getPlacePredictions(options, (predictions, status) => {
      if ('ZERO_RESULTS' === status) {
        this.setState({ whichDropdown: 'error' });
      }

      if ('OK' === status) {
        this.setState({
          predictions,
          whichDropdown: 'location'
        }, () => {
          if (callback) {
            callback();
          }
        });
      }
    });
  }

  highlightText (matchedSubstring, description) {
    let end = 0;
    matchedSubstring.map((match, i) => {
      if (0 === i) {
        end = match.length;
      }
      end = match.offset + match.length;
    });
    const boldLetters = description.substring(0, end);
    const remainingLetters = description.substring(boldLetters.length, description.length);
    return (
      <div className="ellipsis">
        <b className="">{boldLetters}</b><span className="text-gray">{remainingLetters}</span>
      </div>
    );
  }

  predictionItem (props) {
    return (
      <li role="presentation"
        key={props.index}
        id={`metro-list-${props.index}`}
        role="presentation"
        data-value={props.nickname}
        data-geo={props.map_boundaries}
        data-active={props.active}
        data-placeid={props.place_id}
        data-landing={props.landing_url}
        data-name={props.name}
        className= "border-bottom searchbar-metro-option"
        onClick={props.clickFn}
        tabIndex="-1"
        onFocus={this.removeHovered}
      >
        <a href="#" className={`${props.selected} ${props.hovered}`}>
          <div className="row">
            <div className="row-height">
              <div className="col-xs-9 col-height col-middle">
                {props.highlighted_name}
              </div>
            </div>
          </div>
        </a>
      </li>
    );
  }

  onBlurLocation (e) {
    e.stopPropagation();
    this.setState({
      locationFocus: false,
      locationPlaceholder: this.props.intl.formatMessage({ id: 'boards.location_dropdown.where_placeholder', defaultMessage: 'Where?' })
    });
    return setTimeout(() => {
      this.props.errorFn();
    }, 200);
  }

  onFocusLocation (e) {
    this.setState({
      locationFocus: true,
      locationPlaceholder: this.props.intl.formatMessage({ id: 'boards.location_dropdown.enter_address', defaultMessage: 'Enter a city, zip, or address' })
    });
    if (e) {
      e.currentTarget.select();
      const nickname = $(e.currentTarget).attr('data-nickname');
      if (e.currentTarget.value && !nickname) {
        const inputValue = e.currentTarget.value;
        if ('location' === this.state.whichDropdown) {
          return this.autoComplete(inputValue, this.openLocationDropDown);
        }
      }
    }
    return this.openLocationDropDown();
  }

  renderOptions () {
    const { predictions } = this.state;
    if (!predictions) return null;

    return predictions.map((prediction, i) => {
      const { description, place_id, matched_substrings } = prediction;
      let hovered;

      if (0 === i) {
        hovered = 'hovered';
      }

      return {
        hovered: hovered || '',
        name: description,
        highlighted_name: this.highlightText(matched_substrings, description),
        active: true,
        place_id
      };
    }).map((option, i) => {
      return this.predictionItem(Object.assign({}, option, {
        highlighted_name: option.highlighted_name || option.name,
        clickFn: this.onClick,
        index: i,
        selected: this.checkSelected(option)
      }));
    });
  }

  onKeyDown (e) {
    if (40 === e.keyCode) {
      e.preventDefault();
      $('#metro-list-0 a').focus();
    } else if (13 === e.keyCode) {
      if (this.state.predictions) {
        $('#metro-list-0').trigger('click');
        $(e.currentTarget).trigger('blur');
      }
    }
  }

  removeHovered () {
    $('#metro-list-0 a').removeClass('hovered');
  }

  checkSelected (optionProps) {
    const locationValue = this.state.location;
    if (locationValue && (locationValue === optionProps.name)) {
      this.removeHovered();
      return 'dropdown-selected';
    }
  }

  checkForIcon () {
    let icon = '';
    if (!this.props.optional) {
      icon = <span className="required">*</span>;
    }
    return (
      <div className="form-control-feedback">
        {icon}
      </div>
    );
  }

  render () {
    const { menuStatus, predictions, placeId } = this.state;
    const locBlurred = this.state.locationFocus ? '' : 'blurred';
    const { error } = this.props;

    return (
      <div className={`col-xs-12 search-group metro-input dropdown ${menuStatus || ''}`} >
        <input
          aria-haspopup="true"
          aria-expanded="false"
          id="searchbar-input"
          type="text"
          className={`form-control js-searchbar-select-metro ignore-location-clickoutside ${locBlurred} ${error.inputBorder || ''}`}
          tabIndex="0"
          ref="locationInput"
          data-placeid={placeId}
          onBlur={this.onBlurLocation}
          onFocus={this.onFocusLocation}
          onChange={this.onChange}
          onKeyDown={this.onKeyDown}
          placeholder={this.state.locationPlaceholder}
          defaultValue={this.props.location}
        />
        { this.checkForIcon() }
        {
          'location' === this.state.whichDropdown ?
          <ul
            role="menu"
            aria-expanded="false"
            className="dropdown-menu city-dropdown"
            onMouseEnter={this.removeHovered}
          >
            { this.renderOptions() }
            {
              predictions ?
              <li className="text-center" style={{ marginTop: 13, marginBottom: 13 }}>
                <img style={{ width: 150 }} src="/web-2/assets/images/powered_by_google.png?v=rb" alt={ this.props.intl.formatMessage({ id: 'boards.location_dropdown.powered_google', defaultMessage: 'powered by Google' }) } />
              </li> : null
            }
          </ul> :
          <ErrorDropdown
            content={<span>
              <FormattedMessage
                id="boards.location_dropdown.dont_recognize"
                defaultMessage="We don't recognize that location"
              />
            </span>}
            enableClickOutside={this.state.enableLClickOutside}
            origin={this.props.origin}
            closeDropdown={this.closeDropdown}
            ignoreClass="ignore-location-clickoutside"
          />
        }
      </div>
    );
  }
}

LocationDropdown.propTypes = {
  origin: PropTypes.string,
  optional: PropTypes.string,
  clickCallback: PropTypes.func,
  location: PropTypes.string,
  errorFn: PropTypes.func,
  error: PropTypes.object
};

export default injectIntl(clickOutside(LocationDropdown));
